import { render, staticRenderFns } from "./Reward.vue?vue&type=template&id=4b6742a8&scoped=true&"
import script from "./Reward.vue?vue&type=script&lang=js&"
export * from "./Reward.vue?vue&type=script&lang=js&"
import style0 from "./Reward.vue?vue&type=style&index=0&id=4b6742a8&lang=sass&scoped=true&"
import style1 from "./Reward.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6742a8",
  null
  
)

export default component.exports